import GoogleAnalyticsEvent from "dataTransferObjects/googleAnalyticsEvent";
import GoogleAnalyticsEventAction from "enums/googleAnalyticsEventAction";
import GoogleAnalyticsEventCategory from "enums/googleAnalyticsEventCategory";

/* Creates a new instance of a Google Analytics Tdv metric Mixin to track users events when the user subimits a lead. */
export default class EventTrackingRealTimeEventsMixin {
    constructor(model) {
      Object.assign(this, model);
    }
  
    getGoogleAnalyticsData() {
      return new GoogleAnalyticsEvent(
        GoogleAnalyticsEventCategory.RealtimeEvents.toString(),
        GoogleAnalyticsEventAction.DirectLeads.toString(),
        this.marketId);
    }
  }